import { SidebarProvider, useSidebar } from '../context/SidebarContext'
import { Outlet } from 'react-router'
import AppHeader from './AppHeader'
import Backdrop from './Backdrop'
import AppSidebar from './AppSidebar'
import { useLogto } from '@logto/react'
import { useAuth } from '../AuthProvider.ts'
import { useCallback, useMemo } from 'react'

const LayoutContent: React.FC = () => {
	const { signOut } = useLogto()
	const { authUser } = useAuth()
	const { isExpanded, isHovered, isMobileOpen } = useSidebar()

	const isDevEnvironment = useMemo(() => {
		return location.hostname === 'localhost'
	}, [])

	const handleSignOut = useCallback(async () => {
		localStorage.removeItem('accessToken')
		localStorage.removeItem('organizationToken')
		localStorage.removeItem('accessTokenExpiresAt')
		localStorage.removeItem('organizationTokenExpiresAt')
		localStorage.setItem('organicSignOut', 'true')
		await signOut(isDevEnvironment ? import.meta.env.VITE_LOCAL_REDIRECT_URL : import.meta.env.VITE_PROD_REDIRECT_URL)
	}, [signOut])

	return (
		<div className="min-h-screen xl:flex">
			<div>
				<AppSidebar />
				<Backdrop />
			</div>
			<div
				className={`flex-1 transition-all duration-300 ease-in-out ${
					isExpanded || isHovered ? 'lg:ml-[290px]' : 'lg:ml-[90px]'
				} ${isMobileOpen ? 'ml-0' : ''}`}
			>
				<AppHeader user={authUser} logout={handleSignOut} />
				<div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
					<Outlet />
				</div>
			</div>
		</div>
	)
}

const AppLayout: React.FC = () => {
	return (
		<SidebarProvider>
			<LayoutContent />
		</SidebarProvider>
	)
}

export default AppLayout
